import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { UtilityService } from 'src/app/core/shared/utility.service';

@Component({
  selector: 'app-select-period-dialog',
  templateUrl: './select-period-dialog.component.html',
  styleUrls: ['./select-period-dialog.component.scss']
})
export class SelectPeriodDialogComponent implements OnInit {
  periods: String[];
  selected: String;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private utilityService: UtilityService,
  public dialogRef: MatDialogRef<SelectPeriodDialogComponent>) {
    this.periods = this.utilityService.generatePeriod();
    this.selected = this.utilityService.getCurrentPeriodoAvaible();
   }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(null);
  }

  send() {
    const dataChangeVersion = {
      period: this.selected
    };
    this.dialogRef.close(dataChangeVersion);
  }

}
